import * as Actions from "../../actions/app"
import { toggleIdInArray } from "utils/toggle-id-in-array"

const initialState = {
  // orden de servicio
  loading_service_orders: false,
  service_orders: null,
  total_pages_service_orders: 1,
  total_registers_service_orders: 0,
  loading_service_order: false,
  service_order: null,
  loading_crud_service_order: false,
  crud_service_order: false,

  // detalle orden de servicio
  loading_details_service_order: false,
  details_service_order: [],

  saving_detail_service_order: false,
  saved_detail_service_order: false,

  updating_detail_service_order_group_ids: [],
  updated_detail_service_order_group_ids: [],

  updating_detail_service_order_quantity_ids: [],
  updated_detail_service_order_quantity_ids: [],

  deleting_detail_service_order_ids: [],
  deleted_detail_service_order_ids: [],

  // ordenes de tecnico
  loading_crud_detail_service_order: false,
  crud_detail_service_order: false,
  service_orders_tech: null,
  total_pages_service_orders_tech: 1,
  total_registers_service_orders_tech: 0,
}

const vehicleServiceOrderReducer = function (state = initialState, action) {
  switch (action.type) {
    // orden de servicio
    case Actions.LOADING_SERVICE_ORDERS: {
      return {
        ...state,
        loading_service_orders: action.payload,
      }
    }
    case Actions.GET_SERVICE_ORDERS: {
      return {
        ...state,
        service_orders: action.payload.detalles,
        total_pages_service_orders: action.payload.totalPaginas,
        total_registers_service_orders: action.payload.totalRegistros,
      }
    }
    case Actions.GET_SERVICE_ORDER: {
      return {
        ...state,
        loading_service_order: action.payload.loading,
        service_order: action.payload.data,
      }
    }
    case Actions.CRUD_SERVICE_ORDER: {
      return {
        ...state,
        loading_crud_service_order: action.payload.loading,
        crud_service_order: action.payload.crud,
      }
    }

    // detalle orden de servicio
    case Actions.GET_DETAILS_SERVICE_ORDER: {
      return {
        ...state,
        loading_details_service_order: action.payload.loading,
        details_service_order: action.payload.data ?? state.details_service_order,
      }
    }
    case Actions.SAVE_DETAIL_SERVICE_ORDER: {
      return {
        ...state,
        saving_detail_service_order: action.payload.saving ?? state.saving_detail_service_order,
        saved_detail_service_order: action.payload.saved ?? false,
      }
    }
    case Actions.UPDATE_DETAIL_SERVICE_ORDER_GROUP: {
      return {
        ...state,
        updating_detail_service_order_group_ids: toggleIdInArray(state.updating_detail_service_order_group_ids, action.payload.updating_id),
        updated_detail_service_order_group_ids: toggleIdInArray(state.updated_detail_service_order_group_ids, action.payload.updated_id),
      }
    }
    case Actions.UPDATE_DETAIL_SERVICE_ORDER_QUANTITY: {
      return {
        ...state,
        updating_detail_service_order_quantity_ids: toggleIdInArray(state.updating_detail_service_order_quantity_ids, action.payload.updating_id),
        updated_detail_service_order_quantity_ids: toggleIdInArray(state.updated_detail_service_order_quantity_ids, action.payload.updated_id),
      }
    }

    // ordenes de tecnico
    case Actions.CRUD_DETAIL_SERVICE_ORDER: {
      return {
        ...state,
        loading_crud_detail_service_order: action.payload.loading,
        crud_detail_service_order: action.payload.crud,
      }
    }
    case Actions.GET_SERVICE_ORDERS_TECH: {
      return {
        ...state,
        service_orders_tech: action.payload.detalles,
        total_pages_service_orders_tech: action.payload.totalPaginas,
        total_registers_service_orders_tech: action.payload.totalRegistros,
      }
    }

    default: {
      return state
    }
  }
}
export default vehicleServiceOrderReducer
